import React, { FC, ReactElement, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Alert, Col, Form, Row } from "antd";
import { KeyOutlined, UndoOutlined } from "@ant-design/icons";

import { selectSuccessMessage, selectUserResetPasswordErrors } from "../../../redux-toolkit/user/user-selector";
import { resetInputForm } from "../../../redux-toolkit/user/user-slice";
import ContentTitle from "../../../components/ContentTitle/ContentTitle";
import FormInput from "../../../components/FormInput/FormInput";
import IconButton from "../../../components/IconButton/IconButton";
import { updateUserPassword } from "../../../redux-toolkit/user/user-thunks";
import "./ChangePassword.css";

const ChangePassword: FC = (): ReactElement => {
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const errors = useSelector(selectUserResetPasswordErrors);
    const successMessage = useSelector(selectSuccessMessage);
    const { passwordError, password2Error } = errors;

    useEffect(() => {
        dispatch(resetInputForm());
    }, []);

    useEffect(() => {
        if (successMessage) {
            form.resetFields();
        }
    }, [successMessage]);

    const onFormSubmit = (data: { password: string; password2: string }): void => {
        dispatch(updateUserPassword({ ...data }));
    };

    return (
        <div className="cp-page">

            {/* Top bar */}
            <div className="cp-topbar">
                <KeyOutlined className="cp-topbar-icon" />
                <span className="cp-topbar-title">Change Password</span>
            </div>

            {/* Breadcrumb */}
            <div className="cp-breadcrumb">
                Dashboard &rsaquo; Change Password
            </div>

            <div className="cp-body">
                <div className="cp-card">

                    {/* Card header */}
                    <div className="cp-card-header">
                        <KeyOutlined className="cp-card-header-icon" />
                        <span>Update your password</span>
                    </div>

                    <div className="cp-card-body">
                        <Form onFinish={onFormSubmit} form={form}>
                            <Row>
                                <Col span={24}>

                                    {successMessage && (
                                        <Alert
                                            type="success"
                                            message={successMessage}
                                            className="cp-alert-success"
                                            showIcon
                                        />
                                    )}

                                    <div className="cp-hint">
                                        Use at least 8 characters with a mix of letters and numbers.
                                    </div>

                                    <FormInput
                                        title={"New Password"}
                                        titleSpan={10}
                                        wrapperSpan={14}
                                        name={"password"}
                                        error={passwordError}
                                        placeholder={"Enter new password"}
                                        inputPassword
                                    />

                                    <FormInput
                                        title={"Confirm Password"}
                                        titleSpan={10}
                                        wrapperSpan={14}
                                        name={"password2"}
                                        error={password2Error}
                                        placeholder={"Re-enter new password"}
                                        inputPassword
                                    />

                                    <div className="cp-submit-row">
                                        <IconButton title={"Update Password"} icon={<UndoOutlined />} />
                                    </div>

                                </Col>
                            </Row>
                        </Form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ChangePassword;